import { render, staticRenderFns } from "./ActivityFeed.vue?vue&type=template&id=905a5260"
import script from "./ActivityFeed.vue?vue&type=script&lang=js"
export * from "./ActivityFeed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports